import FleetModal, { useAsyncModal } from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { NAPKAPInformation } from '@/libs/fleet-api/services/nap';
import { DatePicker, Divider, Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { FC } from 'react';

type KAPForm = NAPKAPInformation;

export const useKAPModal = () => {
	return useAsyncModal<KAPForm, KAPForm>();
};

const KAPModal: FC<ReturnType<typeof useKAPModal>> = (props) => {
	const { form, fieldName } = useForm<KAPForm>();

	return (
		<FleetModal
			{...props.modal}
			width={940}
			closable={false}
			buttonPosition="end"
			okText="SAVE"
			cancelText="BACK"
			onOk={async () => {
				const values = await form.validateFields();
				props.close(values);
			}}
			afterOpenChange={(isOpen) => {
				if (!isOpen) {
					form.resetFields();
				} else if (props.data) {
					form.setFieldsValue(props.data);
				}
			}}
		>
			<FleetTitle>Informasi KAP</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				labelCol={{ span: 4 }}
				wrapperCol={{ span: 20 }}
				style={{ marginTop: 20 }}
			>
				<Form.Item
					label="Tahun"
					name={fieldName(['year'])}
					rules={[rule.required()]}
					getValueProps={(value) => ({
						value: value && dayjs(value),
					})}
					normalize={(value) => value && dayjs(value).year().toString()}
				>
					<DatePicker.YearPicker />
				</Form.Item>

				<Divider />

				<Form.Item
					label="KAP"
					style={{ marginTop: 20 }}
					name={fieldName('kap')}
					rules={[rule.required()]}
				>
					<Input />
				</Form.Item>

				<Divider />

				<Form.Item
					label="Opini"
					style={{ marginTop: 20 }}
					name={fieldName('opinion')}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>

				<Divider />

				<Form.Item
					label="Keterangan"
					style={{ marginTop: 20 }}
					name={fieldName('description')}
					rules={[rule.required()]}
				>
					<TextArea rows={3} />
				</Form.Item>
			</Form>
		</FleetModal>
	);
};

export default KAPModal;
